"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Product_module_1 = tslib_1.__importDefault(require("./modules/Product.module"));
const GiftVoucher_module_1 = tslib_1.__importDefault(require("./modules/GiftVoucher.module"));
const loadGiftVoucherModule = (initialData) => ({
    hasRouter: false,
    modules: [(0, Product_module_1.default)(initialData), (0, GiftVoucher_module_1.default)()],
});
exports.default = loadGiftVoucherModule;
